import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Card, CardContent, Box, Typography, CardHeader, Stack, Button } from "@mui/material";
import RMSAvatar from "../RMSAvatar";
import AlertMessage from "../../../Common/Alert/AlertMessage";
import { Link } from "react-router-dom";
import { formatDate } from "../../../../utilities/formatters";

import { initiateAppraisal } from "../../../../actions/rmsActions";

import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import NextPlanOutlinedIcon from "@mui/icons-material/NextPlanOutlined";
import AppraisalInitiateFormDialog from "./AppraisalInitiateFormDialog";


function AppraisalStartCard({ appraisalCount, appCode }) {
    const subheader = appraisalCount === 1 ? `${appraisalCount} appraisal found` : `${appraisalCount} appraisals found`;

    const [openDialog, setOpenDialog] = useState(null);
    const [lastDueDate, setLastDueDate] = useState("");
    const [nextDueDate, setNextDueDate] = useState("");
    const [canInitiate, setCanInitiate] = useState(true);

    const handleCloseDialog = () => {
        setLastDueDate("");
        setNextDueDate("");
        setOpenDialog(null);
    };

    const dispatch = useDispatch();

    const handleSave = () => {
        dispatch(initiateAppraisal(appCode, { lastDueDate: formatDate(lastDueDate), nextDueDate: formatDate(nextDueDate)}));
        handleCloseDialog();
        setCanInitiate(false);
    };

    let message = "You do not have an active appraisal configured on this system.";

    if (canInitiate) {
        message = `${message} You will need to initiate a new appraisal`;
    }

    return (
        <>
            <Card sx={{ width: "100%" }} className="card">
                <CardHeader
                    avatar={<RMSAvatar type={"appraisal"} />}
                    title={
                        <Typography variant="h2" className="card-header-title">
                            Appraisals
                        </Typography>
                    }
                    subheader={
                        <Typography component="span" className="card-header-subtitle">
                            {subheader}
                        </Typography>
                    }
                    action={
                        <Stack
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                            spacing={2}
                            sx={{ padding: "8px" }}
                        >
                            {canInitiate && (
                                <Button
                                    variant={"contained"}
                                    color={"primary"}
                                    disableElevation={true}
                                    aria-label="Initiate appraisal"
                                    onClick={() => setOpenDialog("initiate")}
                                    startIcon={<NextPlanOutlinedIcon />}
                                >
                                    Initiate
                                </Button>
                            )}

                            <Button
                                variant={"contained"}
                                color={"neutral"}
                                disableElevation={true}
                                aria-label="List appraisala"
                                component={Link}
                                to={"/rms/appraisals"}
                                endIcon={<KeyboardArrowRightOutlinedIcon />}
                            >
                                List
                            </Button>
                        </Stack>
                    }
                />
                <CardContent>
                    <Box className="card-content">
                        <AlertMessage severity="info" message={message} />
                    </Box>
                </CardContent>
            </Card>

            {openDialog === "initiate" && (
                <AppraisalInitiateFormDialog
                    open={openDialog === "initiate"}
                    onClose={handleCloseDialog}
                    onSave={handleSave}
                    lastDueDate={lastDueDate}
                    setLastDueDate={setLastDueDate}
                    nextDueDate={nextDueDate}
                    setNextDueDate={setNextDueDate}
                    scroll="paper"
                />
            )}
        </>
    );
}

export default AppraisalStartCard;
